//display variable text on screen; 1st is element name, followed by the text you want displayed
function displayText(elem,txt,className, shouldOverwrite, centered, shouldAppend = false)
{
	var domElement = document.getElementById(elem)

	var isTextDisplayed =  domElement.style.display === 'block';

	if (shouldOverwrite === false && isTextDisplayed && !shouldAppend) {
		return;
	}

	if (!className) {
		className='experiment-debrief';
	}

	if(shouldAppend) {
		txt = domElement.innerHTML + txt;
	}

	if (txt != "na" && txt) {
	  domElement.innerHTML = txt;

	  if (elem == 'content') {
	  	domElement.style.top = '120px';
	  }

	  if (centered) {
	  	centerText(domElement);
	  }

	  domElement.style.display = "block";
	  className && (domElement.className += " " + className);
	}
}

function centerText(domElement){
      var content = $(domElement);
      var container = $('#displayScreen');
      var contentHeight = Math.ceil(content.height() / 2),
      contentWidth  = Math.ceil(content.width() / 2);

      content.css({
        top: Math.ceil(container.height() / 2 - contentHeight),
        left: Math.ceil(container.width() / 2 - contentWidth),
      });
}